import * as React from 'react';

import { useQuery } from '@apollo/client';

import ErrorBoundary from '@components/ErrorBoundary';

import { AddToCartButtonProvider, useAddToCartButtonContext } from './context';
import { IAddToCartButtonProps } from './model';
import { addToCartSettings } from './queries/__generated__/addToCartSettings';
import getAddToCartSettings from './queries/addToCartSettings.graphql';
import { BuyButton } from './sharedComponents/BuyButton';
import { SpecialAddToCartModal } from './SpecialAddToCartModal';
import { useMessagesForSpecialModal } from './SpecialAddToCartModal/useMessagesForSpecialModal';
import { ButtonWrapper } from './styled';

const AddToCartCoreComponent: React.FC<IAddToCartButtonProps> = React.memo(
  (props) => {
    const {
      state: {
        product,
        buttonWrapper: WrapperComponent = ButtonWrapper,
        buttonWrapperProps,
        mouseOverBuyButton,
      },
      actions: { showSpecialModal },
    } = useAddToCartButtonContext();
    const { data } = useQuery<addToCartSettings>(getAddToCartSettings);

    const settings = data?.Settings;
    const { isSpecial, description, header } =
      useMessagesForSpecialModal(product);

    const handleShowSpecialModal = () => {
      showSpecialModal(
        <AddToCartButtonProvider {...props}>
          <SpecialAddToCartModal
            description={description}
            productId={product.id}
            productCode={product.productCode}
            settings={settings}
            masterId={product.masterId}
          />
        </AddToCartButtonProvider>,
        header
      );
    };

    return (
      <ErrorBoundary>
        <WrapperComponent {...buttonWrapperProps}>
          <BuyButton
            productId={product.id}
            productCode={product.productCode}
            isSpecialProduct={isSpecial}
            Settings={settings}
            buttonType={mouseOverBuyButton ? 'button' : 'submit'}
            masterId={product.masterId}
            showSpecialModal={handleShowSpecialModal}
          />
        </WrapperComponent>
      </ErrorBoundary>
    );
  }
);

export const AddToCartButton: React.FC<IAddToCartButtonProps> = React.memo(
  (props) => (
    <AddToCartButtonProvider {...props}>
      <AddToCartCoreComponent {...props} />
    </AddToCartButtonProvider>
  )
);
